import React, { useEffect, useState } from "react";
import "./header.scss";
import BrandLogo from "../../assets/images/logo/brandlogo.svg";

const Header = () => {
  const [
    expandSearchInput,
    setExpandSearchInput,
  ] = useState(false);

  const [deviceWidth, setDeviceWidth] = useState(1024);

  useEffect(() => {
    if (typeof window !== "undefined") {
      setDeviceWidth(window.innerWidth);
    }
  }, []);

  return (
    <>
      <header
        className={`header ${
          expandSearchInput ? "expand-search" : ""
        }`}
      >
        <div className="content-left">
          <a href="/" className="logo-wrap">
            <img
              src={BrandLogo}
              className="logo"
              alt="Share.Market logo"
            />
          </a>
          <a href="/blog" className="sub-text">
            <span>Blog</span>
          </a>
        </div>
        <div className="content-right">
          <div
            className={`search ${
              expandSearchInput ? "search-opened" : ""
            }`}
          >
            <span
              className="close-icon"
              onClick={() => {
                deviceWidth <= 600 &&
                  setExpandSearchInput(false);
              }}
            ></span>
            <form
              className="search-form"
              method="GET"
              action={"/blog/search"}
              autoComplete="off"
            >
              <input
                name="q"
                type="search"
                placeholder="Search topic and press Enter"
                className="search-input"
              />
              <span
                className="search-icon"
                onClick={() => {
                  deviceWidth <= 600 &&
                    setExpandSearchInput(true);
                }}
              >
                Search icon
              </span>
            </form>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;
